export class ProductItemColletion {
    constructor() {
        this.productItems = [];
        this.eventListeners = [];
    }

    // Collection

    add(item) {
        if(this.exist(item.serialNo)){
            return;
        }
        this.productItems.push(item);
        item.getImageUrlAsync();
        this.publish('collectionUpdated', this.productItems);
        return this.productItems;
    }

    remove(serialNo) {
        const productWithSerialNoIndex = this.productItems.findIndex((p) => p.serialNo === serialNo);

        if (productWithSerialNoIndex > -1) {
            this.productItems.splice(productWithSerialNoIndex, 1);
        }
        this.publish('collectionUpdated', this.productItems);
        return this.productItems;
    }

    get(serialNo) {
        let productItem = this.productItems.find((p) => p.serialNo === serialNo);
        return productItem;
    }

    multipleProducts() {
        return this.productItems.length > 1;
    }

    clear() {
        this.productItems = [];
        this.publish('collectionUpdated', this.productItems);
        return this.productItems;
    }

    clearAllExceptInitialProduct(){
        let initProductItem = this.getInitialProduct();
        this.productItems = [];
        this.productItems.push(initProductItem);
        this.publish('collectionUpdated', this.productItems);
        return this.productItems;
    }

    exist(serialNo) {
        const productWithSerialNoIndex = this.productItems.findIndex((p) => p.serialNo === serialNo);
        return productWithSerialNoIndex > -1;
    }

    getInitialProduct() {
        let initProductItem = this.productItems.find((p) => p.isInitialProduct);
        return initProductItem;
    }

    getAll() {
        return this.productItems;
    }

    getAllSerialNumbers(includeInitialProduct = true){
        let serialNumbers = [];
        this.productItems.forEach(product => {
            if((includeInitialProduct && product.isInitialProduct) || !product.isInitialProduct) {
                serialNumbers.push(product.serialNo);
            }
        });
        return serialNumbers;
    }

    // Events
    subscribe(fn){
        let eventName = 'collectionUpdated';
        this.eventListeners.push({eventName, fn});
    }

    // to clear the subscriptions when changing actions
    clearSubscriptions(){
        this.eventListeners = [];
    }

    // removeEventListener(){
    //     // Do we need this?
    // }

    publish(eventName, args){
        for(let eventListener of this.eventListeners){
            if(eventListener.eventName === eventName) {
                eventListener.fn(args);
            }
        }
    }

    // Call this to publish event
    productsUpdated() {
        this.publish('collectionUpdated', this.productItems);
    }

}